/**
 *
 * Asynchronously loads the component for AdminVoteValidatorCommentButton
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/AdminVoteValidatorCommentButton/loadable.js